var React = require('react');

function Wheelchair (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.725 2.597V2.6l.034-.002.034.002v-.003a1.298 1.298 0 000-2.593V0l-.034.002L5.725 0v.003a1.3 1.3 0 000 2.594zm5.5 5.913a.855.855 0 00-.692-.76 1.017 1.017 0 00-.328-.055H7.818l-.365-2.997c-.081-.667-.808-1.128-1.624-1.029-.815.099-1.41.721-1.329 1.388l.441 3.625c.019.152.072.292.15.418.153.367.515.625.937.625h1.465A3.508 3.508 0 014.291 11.8 3.537 3.537 0 01.758 8.267a3.523 3.523 0 012.918-3.475.378.378 0 10-.131-.746A4.28 4.28 0 000 8.268a4.296 4.296 0 004.292 4.292 4.275 4.275 0 004.033-2.834h1.298l.227 2.443a.854.854 0 101.701-.159l-.326-3.5z"}));
}

Wheelchair.defaultProps = {"width":"11.555","height":"12.944","viewBox":"0 0 11.555 12.944"};

module.exports = Wheelchair;

Wheelchair.default = Wheelchair;
